import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
/* eslint-disable require-unicode-regexp,prefer-regex-literals */

import { extractSmartLinkEmbed } from '@atlaskit/link-extractors';
import { NodeDataProvider } from '@atlaskit/node-data-provider';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { getStatus, getBaseUrl, getResolverUrl } from '@atlaskit/linking-common';
import DataLoader from 'dataloader';
import { Transformer } from './transformer';
import { CardClient } from '@atlaskit/link-provider';
import { fg } from '@atlaskit/platform-feature-flags';
import { request } from './api';
var BATCH_WAIT_TIME = 50;

// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
var isJiraRoadmapOrTimeline = function isJiraRoadmapOrTimeline(url) {
  return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
};
var isPolarisView = function isPolarisView(url) {
  return url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
};
var isJwmView = function isJwmView(url) {
  return url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
};
var isJiraList = function isJiraList(url) {
  return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
};
var isGiphyMedia = function isGiphyMedia(url) {
  return url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
};
var isProformaView = function isProformaView(url) {
  return url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
};
var isConfluenceWhiteboard = function isConfluenceWhiteboard(url) {
  return (
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match( /*#__PURE__*/_wrapRegExp(/\/wiki\/spaces\/?.*\/whiteboard\/(\d+)(\?\/)?/, {
      resourceId: 1
    })) || url.match(
    /*#__PURE__*/
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    _wrapRegExp(/\/wiki\/spaces\/?.*\/whiteboard\/([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})(\?\/)?/, {
      resourceId: 1
    }))
  );
};
var isConfluenceDatabase = function isConfluenceDatabase(url) {
  return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
};
var isYoutubeVideo = function isYoutubeVideo(url) {
  return url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
};
var isLoomUrl = function isLoomUrl(url) {
  return url.match(
  /*#__PURE__*/
  // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
  _wrapRegExp(/^https:\/\/(.*?\.)?(loom\..*?\/(share|embed))\/([a-zA-Z0-9-]*-)?([a-f0-9]{32})/, {
    videoId: 5
  }));
};
var isJiraDashboard = function isJiraDashboard(url) {
  return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
var isJiraBacklog = function isJiraBacklog(url) {
  return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
var isJiraBoard = function isJiraBoard(url) {
  return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
var isJiraPlan = function isJiraPlan(url) {
  return (
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match( /*#__PURE__*/_wrapRegExp(/https:\/\/.*?\/jira\/plans\/(\d+)/, {
      resourceId: 1
    })) || url.match(
    /*#__PURE__*/
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    _wrapRegExp(/https:\/\/.*?\/jira\/plans\/(\d+)\/scenarios\/(\d+)\/(timeline|summary|calendar|program\/\d+|dependencies)\/?/, {
      resourceId: 1,
      resourceContext: 2
    }))
  );
};
var isJiraVersion = function isJiraVersion(url) {
  return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
var isJiraForm = function isJiraForm(url) {
  return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
var isJiraSummary = function isJiraSummary(url) {
  return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
var isRovoAgentProfilePage = function isRovoAgentProfilePage(url) {
  return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
var isCustomer360LandingPage = function isCustomer360LandingPage(url) {
  return url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
};
var isConfluenceTeamCalendars = function isConfluenceTeamCalendars(url) {
  return (
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match( /*#__PURE__*/_wrapRegExp(/\/wiki\/spaces\/([^\/]+)\/calendars\/([a-zA-Z0-9-]+)/, {
      resourceContext: 1,
      resourceId: 2
    }))
  );
};
var isJiraIssueNavigator = function isJiraIssueNavigator(url) {
  return url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
};
var isAvpVisualizationView = function isAvpVisualizationView(url) {
  return url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
};
export var isJiraWorkItem = function isJiraWorkItem(url) {
  return /\/browse\/((?:\w+)-(?:\d+))/i.test(url);
};
export var EditorCardProvider = /*#__PURE__*/function (_ref) {
  function EditorCardProvider(envKey, baseUrlOverride, product, onResolve, customCardClient) {
    var _this;
    _classCallCheck(this, EditorCardProvider);
    _this = _callSuper(this, EditorCardProvider);
    _this.name = 'editorCardProvider';
    _this.baseUrl = baseUrlOverride || getBaseUrl(envKey);
    _this.resolverUrl = getResolverUrl(envKey, baseUrlOverride);
    _this.transformer = new Transformer();
    _this.onResolve = onResolve;
    _this.requestHeaders = {
      Origin: _this.baseUrl
    };
    _this.providersLoader = new DataLoader(function (keys) {
      return _this.batchProviders(keys);
    }, {
      batchScheduleFn: function batchScheduleFn(callback) {
        return setTimeout(callback, BATCH_WAIT_TIME);
      }
    });
    _this.cardClient = customCardClient !== null && customCardClient !== void 0 ? customCardClient : new CardClient(envKey, baseUrlOverride);
    if (!customCardClient && product) {
      _this.cardClient.setProduct(product);
    }
    return _this;
  }
  _inherits(EditorCardProvider, _ref);
  return _createClass(EditorCardProvider, [{
    key: "nodeDataKey",
    value: function nodeDataKey(node) {
      // We can use URL as a key here, because CardClient returns the same data for the same URL
      // regardless of the type of card (inline, block, embed).
      return node.attrs.url;
    }
  }, {
    key: "fetchNodesData",
    value: function fetchNodesData(nodes) {
      var _this2 = this;
      var promises = nodes.map(function (node) {
        var url = node.attrs.url;
        return _this2.cardClient.fetchData(url);
      });
      return Promise.all(promises);
    }
  }, {
    key: "isNodeSupported",
    value: function isNodeSupported(node) {
      return ['inlineCard', 'blockCard', 'embedCard'].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
    }
  }, {
    key: "batchProviders",
    value: function () {
      var _batchProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keys) {
        var providersData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.fetchProvidersData();
            case 2:
              providersData = _context.sent;
              return _context.abrupt("return", keys.map(function () {
                return providersData;
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function batchProviders(_x) {
        return _batchProviders.apply(this, arguments);
      }
      return batchProviders;
    }()
  }, {
    key: "checkLinkResolved",
    value: function () {
      var _checkLinkResolved = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resourceUrl) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!expValEquals('platform_editor_smart_card_otp', 'isEnabled', true)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 4;
              return this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                  url: resourceUrl
                }
              });
            case 4:
              _context2.t0 = _context2.sent;
              _context2.next = 10;
              break;
            case 7:
              _context2.next = 9;
              return this.cardClient.fetchData(resourceUrl);
            case 9:
              _context2.t0 = _context2.sent;
            case 10:
              response = _context2.t0;
              if (!(getStatus(response) !== 'not_found')) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return", true);
            case 13:
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t1 = _context2["catch"](0);
              return _context2.abrupt("return", false);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 15]]);
      }));
      function checkLinkResolved(_x2) {
        return _checkLinkResolved.apply(this, arguments);
      }
      return checkLinkResolved;
    }()
  }, {
    key: "fetchDataForResource",
    value: function () {
      var _fetchDataForResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resourceUrl) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (!expValEquals('platform_editor_smart_card_otp', 'isEnabled', true)) {
                _context3.next = 7;
                break;
              }
              _context3.next = 4;
              return this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                  url: resourceUrl
                }
              });
            case 4:
              _context3.t0 = _context3.sent;
              _context3.next = 10;
              break;
            case 7:
              _context3.next = 9;
              return this.cardClient.fetchData(resourceUrl);
            case 9:
              _context3.t0 = _context3.sent;
            case 10:
              response = _context3.t0;
              if (!(getStatus(response) !== 'not_found')) {
                _context3.next = 13;
                break;
              }
              return _context3.abrupt("return", response);
            case 13:
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t1 = _context3["catch"](0);
              return _context3.abrupt("return", undefined);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 15]]);
      }));
      function fetchDataForResource(_x3) {
        return _fetchDataForResource.apply(this, arguments);
      }
      return fetchDataForResource;
    }()
  }, {
    key: "extractAriFromData",
    value: function extractAriFromData(responseData) {
      if (responseData.data && 'atlassian:ari' in responseData.data) {
        return responseData.data['atlassian:ari'];
      }
      return undefined;
    }
  }, {
    key: "fetchProvidersData",
    value: function () {
      var _fetchProvidersData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var endpoint, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              endpoint = "".concat(this.resolverUrl, "/providers");
              _context4.next = 3;
              return request('post', endpoint, undefined, this.requestHeaders);
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", {
                patterns: response.providers.reduce(function (allSources, provider) {
                  return allSources.concat(provider.patterns);
                }, []),
                userPreferences: response.userPreferences
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchProvidersData() {
        return _fetchProvidersData.apply(this, arguments);
      }
      return fetchProvidersData;
    }()
  }, {
    key: "loadProviderData",
    value: function () {
      var _loadProviderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.providersLoader.load('providersData');
            case 3:
              this.providersData = _context5.sent;
              _context5.next = 11;
              break;
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);
              // eslint-disable-next-line
              console.error('failed to fetch /providers', _context5.t0);
              this.providersLoader.clear('providerData');
              return _context5.abrupt("return", undefined);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 6]]);
      }));
      function loadProviderData() {
        return _loadProviderData.apply(this, arguments);
      }
      return loadProviderData;
    }()
  }, {
    key: "findPattern",
    value: function () {
      var _findPattern = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.findPatternData(url);
            case 2:
              _context6.t0 = !!_context6.sent;
              if (_context6.t0) {
                _context6.next = 7;
                break;
              }
              _context6.next = 6;
              return this.checkLinkResolved(url);
            case 6:
              _context6.t0 = !!_context6.sent;
            case 7:
              return _context6.abrupt("return", _context6.t0);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function findPattern(_x4) {
        return _findPattern.apply(this, arguments);
      }
      return findPattern;
    }()
  }, {
    key: "doesUrlMatchPath",
    value: function doesUrlMatchPath(path, url) {
      // Using [a-zA-Z0-9] here instead of \w since that includes underscores
      var startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
      var endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
      var escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      var regexPattern = new RegExp("".concat(startingRegex).concat(escapedPath).concat(endingRegex));
      return regexPattern.test(url);
    }
  }, {
    key: "findUserPreference",
    value: function () {
      var _findUserPreference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url) {
        var _this$providersData,
          _this3 = this;
        var userPreferences, defaultAppearance, appearances, allMatchedLabeledAppearances, longestMatchedLabeledAppearance;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.providersData) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return this.loadProviderData();
            case 3:
              userPreferences = (_this$providersData = this.providersData) === null || _this$providersData === void 0 ? void 0 : _this$providersData.userPreferences;
              if (!userPreferences) {
                _context7.next = 12;
                break;
              }
              defaultAppearance = userPreferences.defaultAppearance, appearances = userPreferences.appearances;
              allMatchedLabeledAppearances = appearances.filter(function (_ref2) {
                var urlSegment = _ref2.urlSegment;
                return _this3.doesUrlMatchPath(urlSegment, url);
              });
              if (!(allMatchedLabeledAppearances.length > 0)) {
                _context7.next = 10;
                break;
              }
              longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce(function (previousLabeledAppearance, currentLabeledAppearance) {
                return previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance;
              });
              return _context7.abrupt("return", longestMatchedLabeledAppearance.appearance);
            case 10:
              if (!(defaultAppearance !== 'inline')) {
                _context7.next = 12;
                break;
              }
              return _context7.abrupt("return", defaultAppearance);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function findUserPreference(_x5) {
        return _findUserPreference.apply(this, arguments);
      }
      return findUserPreference;
    }()
  }, {
    key: "findPatternData",
    value: function () {
      var _findPatternData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url) {
        var _this$providersData2;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this.providersData) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return this.loadProviderData();
            case 3:
              return _context8.abrupt("return", (_this$providersData2 = this.providersData) === null || _this$providersData2 === void 0 ? void 0 : _this$providersData2.patterns.find(function (pattern) {
                return url.match(pattern.source);
              }));
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function findPatternData(_x6) {
        return _findPatternData.apply(this, arguments);
      }
      return findPatternData;
    }()
    /**
     *
     * Decides whether the url passed in should be embedded by default
     *
     * protected so that subclasses can override this in order to custom handle links embedded by default
     *
     * @param url
     * @returns 'embed' for the card appearance to embed by default
     */
  }, {
    key: "getHardCodedAppearance",
    value: function getHardCodedAppearance(url) {
      // Replace directly with isJiraPlan(url) on cleanup
      var isJiraPlanEvaluated = isJiraPlan(url);
      var isJiraFormEvaluated;
      if (fg('smartlink_jira_software_form')) {
        isJiraFormEvaluated = isJiraForm(url);
      }
      var isJiraSummaryEvaluated = isJiraSummary(url);
      var isConfluenceTeamCalendarsEvaluated;
      if (fg('tc_smart_link_embed_view')) {
        isConfluenceTeamCalendarsEvaluated = isConfluenceTeamCalendars(url);
      }
      if (isJiraRoadmapOrTimeline(url) || isPolarisView(url) || isJwmView(url) || isJiraList(url) || isGiphyMedia(url) || isProformaView(url) || isConfluenceWhiteboard(url) || isConfluenceDatabase(url) || isYoutubeVideo(url) || isLoomUrl(url) || isJiraDashboard(url) || isJiraBacklog(url) || isJiraBoard(url) || isRovoAgentProfilePage(url) || isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || isJiraIssueNavigator(url) || isAvpVisualizationView(url) && fg('avp_unfurl_shared_charts_embed_by_default_2')) {
        return 'embed';
      }
    }

    /**
     * Make a /resolve call and find out if result has embed capability
     */
  }, {
    key: "canBeResolvedAsEmbed",
    value: (function () {
      var _canBeResolvedAsEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url) {
        var details, embed;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              if (!expValEquals('platform_editor_smart_card_otp', 'isEnabled', true)) {
                _context9.next = 7;
                break;
              }
              _context9.next = 4;
              return this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                  url: url
                }
              });
            case 4:
              _context9.t0 = _context9.sent;
              _context9.next = 10;
              break;
            case 7:
              _context9.next = 9;
              return this.cardClient.fetchData(url);
            case 9:
              _context9.t0 = _context9.sent;
            case 10:
              details = _context9.t0;
              if (details) {
                _context9.next = 13;
                break;
              }
              return _context9.abrupt("return", false);
            case 13:
              if (!(getStatus(details) !== 'resolved')) {
                _context9.next = 15;
                break;
              }
              return _context9.abrupt("return", false);
            case 15:
              embed = extractSmartLinkEmbed(details);
              return _context9.abrupt("return", !!embed);
            case 19:
              _context9.prev = 19;
              _context9.t1 = _context9["catch"](0);
              return _context9.abrupt("return", false);
            case 22:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 19]]);
      }));
      function canBeResolvedAsEmbed(_x7) {
        return _canBeResolvedAsEmbed.apply(this, arguments);
      }
      return canBeResolvedAsEmbed;
    }()
    /**
     * Make a /resolve call and find out if result has datasource capability
     */
    )
  }, {
    key: "getDatasourceFromResolveResponse",
    value: (function () {
      var _getDatasourceFromResolveResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee0(url) {
        var response, datasources;
        return _regeneratorRuntime.wrap(function _callee0$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              if (!expValEquals('platform_editor_smart_card_otp', 'isEnabled', true)) {
                _context0.next = 7;
                break;
              }
              _context0.next = 4;
              return this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                  url: url
                }
              });
            case 4:
              _context0.t0 = _context0.sent;
              _context0.next = 10;
              break;
            case 7:
              _context0.next = 9;
              return this.cardClient.fetchData(url);
            case 9:
              _context0.t0 = _context0.sent;
            case 10:
              response = _context0.t0;
              datasources = response && response.datasources || [];
              if (!(datasources.length > 0)) {
                _context0.next = 14;
                break;
              }
              return _context0.abrupt("return", datasources[0]);
            case 14:
              _context0.next = 19;
              break;
            case 16:
              _context0.prev = 16;
              _context0.t1 = _context0["catch"](0);
              return _context0.abrupt("return", undefined);
            case 19:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 16]]);
      }));
      function getDatasourceFromResolveResponse(_x8) {
        return _getDatasourceFromResolveResponse.apply(this, arguments);
      }
      return getDatasourceFromResolveResponse;
    }()
    /**
     * This is used to determine if the url is a local Jira url or a remote one.
     */
    )
  }, {
    key: "isLocalUrl",
    value: function isLocalUrl(url) {
      return new URL(url).origin === this.baseUrl;
    }
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee1(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        var hardCodedAppearance, _yield$Promise$all, _yield$Promise$all2, matchedProviderPattern, userPreference, data, issueAri, _this$onResolve, isSupported, providerDefaultAppearance, preferredAppearance, canItBeEmbed, datasource, id, parameters;
        return _regeneratorRuntime.wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              if (!(shouldForceAppearance === true)) {
                _context1.next = 3;
                break;
              }
              return _context1.abrupt("return", this.transformer.toSmartlinkAdf(url, appearance));
            case 3:
              hardCodedAppearance = this.getHardCodedAppearance(url);
              _context1.next = 6;
              return Promise.all([this.findPatternData(url), this.findUserPreference(url)]);
            case 6:
              _yield$Promise$all = _context1.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              matchedProviderPattern = _yield$Promise$all2[0];
              userPreference = _yield$Promise$all2[1];
              if (!fg('issue-link-suggestions-in-comments')) {
                _context1.next = 16;
                break;
              }
              if (!(isJiraWorkItem(url) && this.isLocalUrl(url))) {
                _context1.next = 16;
                break;
              }
              _context1.next = 14;
              return this.fetchDataForResource(url);
            case 14:
              data = _context1.sent;
              if (data) {
                issueAri = this.extractAriFromData(data);
                if (issueAri) {
                  (_this$onResolve = this.onResolve) === null || _this$onResolve === void 0 || _this$onResolve.call(this, url, issueAri);
                }
              }
            case 16:
              if (!(shouldForceAppearance === false && userPreference === 'url')) {
                _context1.next = 18;
                break;
              }
              return _context1.abrupt("return", Promise.reject(undefined));
            case 18:
              _context1.t0 = !!matchedProviderPattern;
              if (_context1.t0) {
                _context1.next = 23;
                break;
              }
              _context1.next = 22;
              return this.checkLinkResolved(url);
            case 22:
              _context1.t0 = _context1.sent;
            case 23:
              isSupported = _context1.t0;
              if (!isSupported) {
                _context1.next = 39;
                break;
              }
              providerDefaultAppearance = matchedProviderPattern === null || matchedProviderPattern === void 0 ? void 0 : matchedProviderPattern.defaultView;
              preferredAppearance = shouldForceAppearance === undefined ?
              // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
              hardCodedAppearance || appearance :
              // User preferred appearance. It would be either one that has matching domain/path pattern OR
              // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
              userPreference ||
              // If user's default choice is "inline" or user hasn't specified preferences at all,
              // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
              (isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined) && hardCodedAppearance ||
              // If non match, we see if this provider has default appearance for this particular regexp
              providerDefaultAppearance ||
              // If not, we pick what editor (or any other client) requested
              appearance;
              if (!(preferredAppearance === userPreference && userPreference === 'embed')) {
                _context1.next = 32;
                break;
              }
              _context1.next = 30;
              return this.canBeResolvedAsEmbed(url);
            case 30:
              canItBeEmbed = _context1.sent;
              if (!canItBeEmbed) {
                preferredAppearance = 'inline';
              }
            case 32:
              _context1.next = 34;
              return this.getDatasourceFromResolveResponse(url);
            case 34:
              datasource = _context1.sent;
              if (!datasource) {
                _context1.next = 38;
                break;
              }
              id = datasource.id, parameters = datasource.parameters;
              return _context1.abrupt("return", this.transformer.toDatasourceAdf({
                id: id,
                parameters: parameters,
                // in the future when we support multiple views, we will need to pass this in as a parameter
                // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                views: [{
                  type: 'table'
                }]
              }, url));
            case 38:
              return _context1.abrupt("return", this.transformer.toSmartlinkAdf(url, preferredAppearance));
            case 39:
              _context1.next = 44;
              break;
            case 41:
              _context1.prev = 41;
              _context1.t1 = _context1["catch"](0);
              // eslint-disable-next-line
              console.warn("Error when trying to check Smart Card url \"".concat(url, "\"").concat(_context1.t1 instanceof Error ? " - ".concat(_context1.t1.name, " ").concat(_context1.t1.message) : ''), _context1.t1);
            case 44:
              return _context1.abrupt("return", Promise.reject(undefined));
            case 45:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 41]]);
      }));
      function resolve(_x9, _x0, _x1, _x10) {
        return _resolve.apply(this, arguments);
      }
      return resolve;
    }()
  }]);
}(NodeDataProvider);
export var editorCardProvider = new EditorCardProvider();
// eslint-disable-next-line @atlaskit/editor/no-re-export